if (window.Promise && typeof Promise.allSettled !== 'function' && typeof Promise.all === 'function') {
    Promise.allSettled = function allSettled(promises) {
        return Promise.all(promises.map((p) => {
            return p.then((value) => {
                return { status: 'fulfilled', value }
            }).catch((reason) => {
                return { status: 'rejected', reason }
            })
        }))
    }
}
